import React from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch, NavLink } from 'react-router-dom';
import { IoIosArrowBack } from "react-icons/io";
import { useTranslation } from 'react-i18next';
import NotificationsList from '../NotificationsList/NotificationsList';

function NotificationsArchive(props) {
    const { t } = useTranslation();
    let { url } = useRouteMatch();
    const { eventID } = props;
    const partnerID = localStorage.getItem('partnerID');
    const { userID } = useSelector(state => state.user);

    return (
        <>
            <div className="row" style={{ marginBottom: '30px' }}>
                <div className="col">
                    <NavLink
                        to={url.replace('/notifications', '')}
                        style={{position: 'relative', background: 'white', padding: '6px 15px', borderRadius: '2px', marginBottom: '20px' }}
                    >
                        <IoIosArrowBack /> {t('general.back')}
                    </NavLink>
                </div>
            </div>

            <NotificationsList
                partnerID={partnerID}
                userID={userID}
                eventID={eventID}
                limit={8}
                archive
            />
        </>
    );
}

export default NotificationsArchive;
